import { CountryEnv } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_TW_GU || "gutw-sth-sb-proxy",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_TW_GU || 26360,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_TW_GU || 26361,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_TW_GU || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_TW_GU || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_TW_GU || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_TW_GU || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  faqUrl: "https://faq-tw.gu-global.com/",
  showAboutApp: true
};

export default _countryEnv;
